<template>
    <div class="indexCont" oncontextmenu="return false">
        <div class="mainCont">
            <el-button class="gt_back" icon="el-icon-arrow-left" size="small" @click="goBack()">返回</el-button>
            <div class="trainVideo">
                <div class="videoParent">
                    <div class="videoLeft">
                        <div class="trainName">
                            <div></div>
                            <div>{{trainName}}课程</div>
                            <div @click="clickCollect()">
                                <div class="isCollect" v-show="!isCollect">
                                    <img src="../../../assets/images/common/collectVideo1.png" alt="">
                                    收藏
                                </div>
                                <div class="isCollect" v-show="isCollect">
                                    <img src="../../../assets/images/common/collectVideo2.png" alt="">
                                    已收藏
                                </div>
                            </div>
                        </div>
                        <div class="player" v-show="$IsPc() ? (!centerDialogVisible && !testDialogVisible && !DialogVisibleCert && !dialogFormVisible2 && !personDialogVisible) :true ">
                        <!-- <div class="player" v-show="isShowMobileVideo"> -->
                            <video-player class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                :playsinline="true"
                                style="object-fit:fill"
                                :options="playerOptions"
                                :x5-video-player-fullscreen="true"
                                @pause="onPlayerPause($event)"
                                @play="onPlayerPlay($event)"
                                @ended="onPlayerEnded($event)"
                                @fullscreenchange="onFullscreenChange($event)"
                                @click="fullScreen"
                                @timeupdate="onPlayerTimeupdate($event)"
                                @ready="playerReadied"
                                @waiting="onPlayerWaiting($event)"
                            >
                            </video-player>
                        </div>
                        <div class="parentCont" v-show="$IsPc() ? (centerDialogVisible || testDialogVisible || DialogVisibleCert || dialogFormVisible2 || personDialogVisible) :false ">
                        </div>
                        <div class="timeRecoder" v-show="isShowBtn && !linkFlag">
                            {{lookUp ? "上次已观看完" :" 上次观看至：" + showVideoTime}} 
                            <!-- <span class="tip">视频首次播放无法拖动</span> -->
                        </div>
                        <!-- <div class="comBtn" @click="isPlaySub()" v-show="isShowBtn">提交学习进度</div> -->
                    </div>
                    <div class="videoRight">
                        <div class="videoTitle">
                            {{coursename}}{{totalPercent ? '（' + totalPercent + '%）' : ""}}
                        </div>
                        <div class="rightList" v-if="!noVideoList">
                            <div class="rightVideoList">
                                <div class="videoItem" v-for="(item6,index6) in videoList" :key="index6">
                                    <div class="leftImg" @click="addSrc(item6,index6)">
                                        <img :src="$config.baseApi + item6.resourceImage" alt="">
                                        <div v-if="currentIndex == index6" class="shadow" >当前观看</div>
                                    </div>
                                    <div class="rightTxt">
                                        <div class="title">{{item6.resourceName}}</div>
                                        <div class="studyTime">
                                            学习时长:{{item6.learnTime}}分钟
                                            <img class="lock" v-if="item6.locked == 1 ? true : false" src="../../../assets/images/common/lock3.png" alt="">
                                        </div>
                                        <div class="studyProgress">
                                            <div>学习进度：</div>
                                            <div>
                                                <el-progress :percentage="parseFloat(item6.learnPercent)" :color="customColorMethod" :stroke-width="7" ></el-progress>
                                            </div>
                                        </div>
                                        <!-- <div class="testBtn" v-if="item6.paperStatus == 1 ? true : false" @click="goTestBtn(item6)">{{item6.resourceName}}考试</div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="newTestBtn" v-if="botTestData.paperStatus == 1" @click="goTestBtn(botTestData)">
                                <div class="jj">
                                    <img src="../../../assets/images/common/cart2.png" alt="">
                                    <span>{{coursename}}考试</span>
                                </div>
                            </div>
                        </div>
                        <div class="noData" v-if="noVideoList">
                            暂无视频列表
                        </div>
                    </div>
                </div>
                <div class="videoList" v-if="videoList.length">
                    <div class="title">{{coursename}}{{totalPercent ? '（' + totalPercent + '%）' : ""}}</div>
                    <div class="videoCont">
                        <div class="trainItem" v-for="(item,index) in videoList" :key="index">
                            <div class="t_cont">
                                <div class="mImg">
                                    <img :src="$config.baseApi + item.resourceImage" alt=""  @click="addSrc(item,index)">
                                    <div v-if="currentIndex == index" class="mobileShadow">当前观看</div>
                                </div>
                                <div class="mTxt">
                                    <p class="resourceName">{{item.resourceName}}</p>
                                    <p>学习时长：{{item.learnTime}}分钟</p>
                                    <div>
                                        <div class="mProgress">学习进度：
                                            <img v-if="item.locked == 1 ? true : false"  class="lock" src="../../../assets/images/common/lock3.png" alt="">
                                        </div>
                                        <el-progress :percentage="parseFloat(item.learnPercent)" :color="customColorMethod" :stroke-width="7" ></el-progress>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mobileTestBg" v-if="botTestData.paperStatus == 1" @click="goTestBtn(botTestData)">
                            <img src="../../../assets/images/common/footLogo.png" alt="" class="topImg"> 
                            <img src="../../../assets/images/common/cart2.png" alt="" class="centerImg"> 
                            <div class="mtxt">{{coursename}}考试</div>
                        </div>
                    </div>
                </div>
                <div class="instroduceP">
                    <div class="proTitle">培训介绍</div>
                    <div class="teacherName">培训老师：{{teacherName ? teacherName : "暂无"}}</div>
                    <div class="introduce" >培训简介：<span v-html="introduce ? introduce : '暂无简介'"></span></div>
                </div>
            </div>
        </div>
         <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="详情" :url="redirectUrl"></MobileComNav>
        </div>
         <!-- 弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <!-- <span>您已学习{{Math.ceil(count / 60)}}分钟，确定提交？</span> -->
            <span>{{submitTxt}}</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="cancelSubmit()">取 消</el-button>
            <el-button type="primary" @click="submit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 去考试弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="testDialogVisible"
            :show-close="false"
            :width="dialogWidth"
            center>
            <span>是否去考试？</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="cancelTest()">取 消</el-button>
            <el-button type="primary" @click="goTest()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 证书 -->
        <el-dialog
            :visible.sync="DialogVisibleCert"
            :width="certDialogWidth"
            :before-close="handleClose"
            :close-on-press-escape="false"
            center
            class="comTrain">
            <div class="certPic">
                <img src="../../../assets/images/common/certPic.jpg" alt="" v-if="isShowCetrtPic">
                <img :src="$config.baseApi + certPic" alt="" v-else>
                <!-- <div class="cert_txt">
                    <div class="username">{{username}}</div>
                    <div class="certCode">编号No：{{certCode}}</div>
                    <div class="time">日期Date：{{certTime}}</div>
                </div> -->
            </div>
        </el-dialog>
        <!-- 判断填写信息弹窗 -->
        <el-dialog
            title="用户信息"
            :visible.sync="personDialogVisible"
            :width="dialogWidth"
            :show-close="false"
            :close-on-press-escape="false" 
            :close-on-click-modal="false"
            class="commonDialog">
            <span class="personMess">
                <div>用户没有录入信息，快去个人中心填写信息</div>
                <div @click="goPerson()">去个人中心</div>
            </span>
        </el-dialog>
        <!-- 填写用户信息 -->
        <el-dialog title="用户信息" 
                    :visible.sync="dialogFormVisible2" 
                    center
                    :close-on-press-escape="false" 
                    :close-on-click-modal="false"
                    :show-close="false"
                    :width="dialogWidth"
                    class="commonDialog">
            <el-form :model="form2" ref="form2">
                <el-form-item label="姓名" prop="name" :label-width="formLabelWidth" :rules="{required: true, message:'姓名不能为空'}">
                    <el-input v-model="form2.name" type="name" autocomplete="off" placeholder=" 请输入考生姓名"></el-input>
                </el-form-item>
                <el-form-item label="公司" prop="company" :label-width="formLabelWidth" :rules="{required: true, message:'公司不能为空'}">
                    <el-input v-model="form2.company" type="company" autocomplete="off" placeholder=" 请输入公司"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="department" :label-width="formLabelWidth" :rules="{required: true, message:'部门不能为空'}">
                    <el-input v-model="form2.department" type="department" autocomplete="off" placeholder=" 请输入部门"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="mobile" :label-width="formLabelWidth" :rules="{required: true, message:'联系方式不能为空'}">
                    <el-input v-model="form2.mobile" type="mobile" autocomplete="off" placeholder=" 请输入联系方式"></el-input>
                </el-form-item>
            </el-form>
            <div class="personTip">提示：请如实填写以上信息，如有不实信息系统账号将自动清除</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="goBack()">取 消</el-button>
                <el-button type="primary" @click="submitPerson('form2')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    import timeChange from "../../../assets/js/libs/timeChange";
    import getQuery from "../../../assets/js/libs/getQuery.js";
    export default {
        data(){
            return {
                videoWidth: 800,
                videoHeight:360,
                centerDialogVisible: false,
                testDialogVisible:false,
                dialogWidth: '30%',
                videoSrc:"",
                isShowBtn:true,
                startTime:"",
                learnTime:"",
                DialogVisibleCert:false,
                certDialogWidth:"5rem",
                isShowCetrtPic:true,
                username:"",
                certCode:"",
                certTime:"",
                certPic:"",
                trainName:"",
                teacherName:"",
                introduce:"",
                linkResourceId:"",
                linkCompanyId:"",
                redirectUrl:"./train",
                linkFlag:false,
                paperTotalFlag:false,
                poster:"",
                personDialogVisible:false,
                dialogFormVisible2:false,
                formLabelWidth:"65px",
                form2: {
                    name: '',
                    company:'',
                    department: '',
                    mobile:''
                },
                fromTo:2,  //来源，2：pc  1：wx
                percentage: 70, //进度条百分比
                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.25, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4",
                        // src: "https://v2admin.ahjyjyzx.com/uploads/test/first.mp4"
                        src:""
                    }],
                    poster: "",
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        // timeDivider: false,
                        // durationDisplay: false,
                        // remainingTimeDisplay: false,
                        progressControl: true, //是否显示进度条
                        fullscreenToggle: true  //全屏按钮
                    }
                },
                gklog: '', //视频观看时长
                paused:true,
                timer:"",
                timer2:"",
                count:0,
                durTime:0,
                videoList:"",
                videoTotalTime:0,
                isPlay:false ,//是否播放
                newResourId:"",
                showVideoTime:"", //显示观看时间（1:30）
                totalPercent:"",
                videoNumData:"",
                submitTxt:"",
                isPlayEnd:false ,//是否是播放完 
                isWatchAfter:false, //观看进度是否大于95%
                lookUp:false, //是否看完
                noVideoList:false,
                currentIndex:0,
                txtShowTest:false,
                txtResourceId:"",
                botTestData:"",
                isCollect:false,
                linkCourseId:'', //外部的分组id
                linkCourseName:'', //外部的分组名
                timerInstance: null, // 定时自动提交

                curPageUrl:'',//当前路由
                lastRealTime:'',//上一次观看时长
                realTimer:null,//计时器
                realTime:1,//实际观看秒数
            }
        },
        components: {
            MobileComNav
        },
        methods:{
            // 点击按钮触发是否收藏
            clickCollect(){
                // let trainLink = window.location.href
                // if(trainLink.indexOf('companyId') > -1 && trainLink.indexOf('resourceId') > -1){
                //     console.log(this.linkResourceId)
                // }else{
                //     console.log(this.newResourId)
                // } 
                // this.isCollect = !this.isCollect
                if(this.id){
                    if(this.isCollect){
                        this.cancelCollectVideo(this.id)
                    }else{
                        this.collectVideo(this.id)
                    }
                }else{
                    this.$message({
                        message:"确少参数id",
                        type:'error'
                    })
                }
            },
            // 收藏视频
            collectVideo(courseId){
                this.$ajax({
                    url:this.$config.baseApi + "/course/favorite/add/" + courseId,
                    method:'post'
                }).then(res=>{  
                    if(res.code == 1){
                        this.isCollect = true
                        this.$message({
                            message:"收藏成功",
                            type:'success'
                        })
                    }
                })
                
            },
            // 取消收藏视频
            cancelCollectVideo(courseId){
                this.$ajax({
                    url:this.$config.baseApi + "/course/favorite/cancel/" + courseId,
                    method:'post'
                }).then(res=>{  
                    if(res.code == 1){
                        this.isCollect = false
                        this.$message({
                            message:"已取消收藏",
                            type:'success'
                        })
                    }
                })
            },
            // 判断是否被收藏
            checkCollect(){
                if(this.id){
                    this.$ajax({
                        url:this.$config.baseApi + "/course/favorite/check/" + this.id,
                        method:'post'
                    }).then(res=>{  
                        if(res.code == 1 && res.data){
                            this.isCollect = true
                        }else if(res.code ==1 && !res.data){
                            this.isCollect = false
                        }
                    })
                }
            },
            goBack(){
                this.$router.push(this.redirectUrl)
            },
            // 点击去考试文字
            goTestBtn(item){
                // if(this.totalPercent < 95){
                //     this.$message({
                //         message:'请参加完培训后再考试哦',
                //         duration:"5000"
                //     })
                // }else{
                //     this.testDialogVisible = true;
                //     this.txtShowTest = true; //点击去考flag
                //     this.txtResourceId = item.resourceId
                // }
                this.testDialogVisible = true;
                this.txtShowTest = true; //点击去考flag
                this.txtResourceId = item.resourceId
                
            },
            cancelTest(){
                this.testDialogVisible = false;
                this.txtShowTest = false;
                if(!this.linkFlag){
                    this.getGroupDetail(this.id)
                    // 只有当视频播放完了取消时才能调用跳下一个视频
                    if(this.isPlayEnd){
                        this.playVideo()    
                    }
                }
            },
            cancelSubmit(){
                this.centerDialogVisible = false;
                this.isPlayEnd = false;
            },
            isPlaySub(){
                if(!this.isPlay){
                     this.$message({
                        message:"观看后提交进度",
                    })
                }else{

                    let min = parseInt(this.gklog /  60);
                    let se = parseInt(this.gklog % 60)
                   
                    this.submitTxt = "您已观看" + min + '分钟'+ se + "秒，确定提交？"
                    this.centerDialogVisible = true;
                }
            },
            // 获取学习时间
            getTime(){
                // (原始video)
                // this.$nextTick(()=>{
                //     let myVideo=document.getElementById("media");  
                //     // 这边必须是箭头函数，否则会出现this指向问题。
                //     myVideo.addEventListener("timeupdate",()=>{
                //         let timeDisplay = Math.floor(myVideo.currentTime);
                //         this.learnTime = Math.ceil(timeDisplay/60);
                //         return this.learnTime
                //     },false); 
                // })

                // 进入页面到提交用时
                this.timer2 =  setInterval(()=>{
                    this.count += 1
                },1000)
                
            },
            submit(){
                // this.centerDialogVisible = false;
                let trainLink = window.location.href
                if(trainLink.indexOf('companyId') > -1 && trainLink.indexOf('resourceId') > -1){
                    this.summitSpeed(this.linkResourceId);
                }else{
                    this.summitSpeed(this.newResourId);
                } 
            },
            //获取详情（外部进来）
            getDetail(id){
                this.$ajax({
                    url:this.$config.baseApi + "/material/resource/" + id,
                    method:'get'
                }).then(res=>{
                    if(res.code == 1){
                        let content = res.data.content;
                        if(content && content.indexOf('mp4') > -1){
                            this.playerOptions.sources[0].src = process.env.VUE_APP_FILE_URL + content
                        }else if(content && content.indexOf('mp4') == -1){
                            this.isShowBtn = false;
                            this.playerOptions.notSupportedMessage = "此视频暂无法播放，请稍后再试"
                            this.$message({
                                message:"暂无视频"
                            })
                        }else{
                            this.isShowBtn = false;
                            this.playerOptions.poster = require("../../../assets/images/home/videobg.png")
                            this.$message({
                                message:"资源已锁定",
                                duration:"6000",
                                showClose: true,
                            })
                        }
                        this.introduce = res.data.introduce
                        this.teacherName = res.data.teacherName;
                        this.trainName = res.data.name;

                        // 获取列表分类
                        let courseId = res.data.courseId
                        this.linkCourseId = courseId
                        this.linkCourseName = res.data.courseName
                        // 判断是否被收藏
                        this.checkCollect()
                        this.getGroupDetail(courseId)
                        // 第一次进入判断是否需要能拖动进度条
                        this.isMoveAble(id)
                    }else{
                        this.$message({
                            message:res.msg,
                            type:"error"
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                    let link = window.location.href;
                    if(link.indexOf('code') == -1){
                        localStorage['link'] = window.location.href
                    }
                })
            },
            // 内部详情
            getGroupDetail(id){
                this.$ajax({
                    url:this.$config.baseApi + "/account/wx/course/" + id,
                    method:'post'
                }).then(res=>{ 
                    if(res.code == 1){
                        this.videoList = res.data;
                        let nowVideoList = res.data
                        if(!res.data.length){
                            this.noVideoList = true;
                            this.isShowBtn = false;
                            this.playerOptions.notSupportedMessage = "此视频暂无法播放，请稍后再试"
                            this.$message({
                                message:"暂无视频"
                            })
                        }else{
                            let num = 0
                            // for(let i in res.data){
                            //     num += Number(res.data[i].learnPercent)
                            // }
                            nowVideoList.forEach(item=>{
                                if(item.resourceName==this.trainName) {
                                    num = item.learnPercent
                                }
                            })
                            // this.totalPercent = (num / res.data.length).toFixed(2)
                            this.totalPercent = num
                            this.isWatchAfter = this.totalPercent > 99 ? true : false;

                            // 如果是外部链接判断当前链接视频处于第几个播放
                            let trainLink = window.location.href
                            if(trainLink.indexOf('companyId') > -1 && trainLink.indexOf('resourceId') > -1){
                                this.videoList.forEach((item,index) =>{
                                    if(item.resourceId == this.linkResourceId){
                                        this.currentIndex = index
                                        // 考试按钮
                                        this.botTestData = this.videoList[this.videoList.length - 1]
                                    }
                                })
                            }
                        }
                    }
                }).catch(err =>{
                    let link = window.location.href;
                    if(link.indexOf('code') == -1){
                        localStorage['link'] = window.location.href
                    }
                })
            },
            // 判读进度条是否能拖动
            isMoveAble(resourceId){
                this.$ajax({
                    url:this.$config.baseApi + "/material/resource/isMoveAble/" + resourceId,
                    method:'get',
                }).then(res=>{
                    if(res.code ==  1){
                        this.playerOptions.controlBar.progressControl = true;
                        this.playerOptions.playbackRates = [0.7, 1.0, 1.25, 1.5, 2.0]
                    }else if(res.code == 2){
                        // this.playerOptions.controlBar.progressControl = false;
                        this.playerOptions.controlBar.progressControl = true;
                        this.playerOptions.playbackRates = [0.7, 1.0, 1.25, 1.5, 2.0]
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 进入播放第一个
            firstVideo(id){
                this.$ajax({
                    url:this.$config.baseApi + "/account/wx/course/" + id,
                    method:'post'
                }).then(res=>{ 
                    if(res.code == 1){
                        this.videoList = res.data;
                        this.botTestData = res.data[res.data.length - 1]
                        this.addSrc(this.videoList[0],0)
                    }
                }).catch(err =>{
                   
                })
            },
            // 赋值视屏和简介
            addSrc(data,idx){
                let nowTime = new Date().getTime()
                let startTime = new Date(data.startTime).getTime()
                let endTime = new Date(data.endTime).getTime()
                if(nowTime>=startTime&&nowTime<=endTime||startTime==0&&endTime==0) {
                    // 切换视频验证
                    let allowNext = true
                    let prevVideo = this.videoList.slice(0, idx)
                    if (prevVideo.length) {
                        prevVideo.forEach(item => {
                            if (parseInt(item.learnPercent) < 95) return allowNext = false
                        })
                    }
                    // if (!allowNext) {
                    //     return this.$message.error('对不起，您需要先观看之前的视频')
                    // }
                    //  1为锁定资源
                    this.playerOptions.controlBar.progressControl = true;
                    this.playerOptions.playbackRates = [0.7, 1.0, 1.25, 1.5, 2.0];
                    this.gklog = 0;
                    this.isPlayEnd = false;
                    this.lookUp = false;
                    this.paperTotalFlag = false;
                    this.currentIndex = idx
                    localStorage['videoNum'] = idx
                    if(data.locked == 1){
                        this.isShowBtn = false;
                        this.playerOptions.poster = require("../../../assets/images/home/videobg.png")
                        this.playerOptions.sources[0].src = "";
                        this.$message({
                            message:"资源已锁定",
                            duration:"6000",
                            showClose: true,
                        })
                    }else{
                        this.$message({
                            message:"即将播放" + data.resourceName + "课程",
                            type:'success',
                            duration:"6000"
                        })
                        this.isShowBtn = true;
                        this.playerOptions.poster = ""
                        this.playerOptions.sources[0].src = process.env.VUE_APP_FILE_URL + data.resourceContent;
                    }
                    this.introduce = data.resourceIntroduce
                    this.teacherName = data.teacherName
                    this.trainName = data.resourceName;
                    if(data.learnPercent != 100){
                        // this.gklog = data.videoTime;
                        // this.gklog = data.progress;
                        if(data.progress>=data.resourceTotalTime) {
                            this.gklog = 0
                        } else {
                            this.gklog = data.progress;
                        }
                    }else{
                        this.lookUp = true
                    }
                    clearInterval(this.realTimer);
                    this.realTimer = null
                    this.realTime = 1
                    this.newResourId = data.resourceId;
                    this.lastRealTime = data.videoTime
                    this.showVideoTime = this.changeSecond(this.gklog);
                    this.linkResourceId = data.resourceId
                    this.newPaperList2(this.newResourId);
                    this.isMoveAble(data.resourceId)
                } else {
                    this.$message.error('当前不在设定期限内，不可学习');
                }
            },
            // 提交进度
            summitSpeed(id){
                let url = this.$config.baseApi + "/material/resource/learn";
                this.durTime = Math.ceil(this.count / 60);
                clearInterval(this.timer2);
                //观看进度
                // this.isWatchAfter = this.gklog / this.videoTotalTime > 0.95 ? true : false;
                this.$ajax({
                    url:url,
                    method:'post',
                    data:JSON.stringify({
                        progress:Math.ceil(this.gklog),
                        videoTime:this.realTime+ this.lastRealTime,
                        // videoTime:Math.ceil(this.gklog), //观看时间
                        learnTime:this.durTime,//学习时间
                        videoTotalTime:Math.ceil(this.videoTotalTime), //视频总时长
                        resourceId:id,
                        startTime:this.startTime,
                        fromTo:this.fromTo
                    })
                }).then(res=>{
                    if(res.code == 1){
                        // this.$message({
                        //     message:res.msg,
                        //     type:'success'
                        // });
                        this.getGroupDetail(this.id);
                        if(res.data.certStatus){
                            this.DialogVisibleCert=true,
                            this.username = res.data.certVo.username;
                            this.certCode = res.data.certVo.certCode;
                            this.certTime = res.data.certVo.createTime.slice(0,10);
                            let certPic = res.data.certVo.certPic;
                            if(certPic){
                                this.certPic = certPic;
                                this.isShowCetrtPic = false;
                            }
                        }else{
                            // 有试卷并且观看了95%可以去考试
                            // if(this.paperTotalFlag && this.isWatchAfter){
                            //     this.testDialogVisible = true;
                            // }else{
                            //      if(!this.linkFlag){
                            //         this.getGroupDetail(this.id);
                            //          // 只有当视频播放完了取消时才能调用跳下一个视频
                            //         if(this.isPlayEnd){
                            //             this.playVideo()
                            //         }
                            //     }
                            // }
                            if(!this.linkFlag){
                                // this.getGroupDetail(this.id)
                                // 有试卷并且观看了95%可以去考试
                                setTimeout(()=>{
                                    if(this.paperTotalFlag && this.isWatchAfter){
                                        this.testDialogVisible = true;
                                    }else{
                                        if(this.isPlayEnd){
                                            this.playVideo()
                                        }
                                    }
                                },300)
                               
                            }else{
                                if(this.paperTotalFlag){
                                    this.testDialogVisible = true;
                                }
                            }
                        }
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 绑定相关资源
            resourceBind(){
                this.$ajax({
                    url:this.$config.baseApi + "/material/resource/binding",
                    method:'post',
                    data:JSON.stringify({
                        'resourceId':this.linkResourceId,
                        'companyId':this.linkCompanyId
                    }),
                }).then(res=>{
                    if(res.code ==  1){
                        this.newPaperList2(this.linkResourceId);
                        this.getDetail(this.linkResourceId);
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            //去考试
            goTest(){
                this.testDialogVisible = false;
                let trainLink = window.location.href
                if(trainLink.indexOf('companyId') > -1 && trainLink.indexOf('resourceId') > -1){
                    this.newPaperList(this.linkResourceId)
                }else if(this.txtShowTest){
                    // 点击了文本
                    this.txtShowTest = false
                    this.newPaperList(this.txtResourceId)
                }else{
                    //正常弹窗 
                    this.newPaperList(this.newResourId)
                }
            },
            //关闭证书
            handleClose(done){
                done();
                // if(this.paperTotalFlag && this.isWatchAfter){
                //     this.testDialogVisible = true;
                // }else{
                //     if(!this.linkFlag){
                //         this.getGroupDetail(this.id)
                //     }
                //      // 只有当视频播放完了取消时才能调用跳下一个视频
                //     if(this.isPlayEnd){
                //         this.playVideo()
                //     }
                // }
                // 不是外部链接
                if(!this.linkFlag){
                    this.getGroupDetail(this.id);
                    setTimeout(()=>{
                        if(this.paperTotalFlag && this.isWatchAfter){
                            this.testDialogVisible = true;
                        }else{
                            if(this.isPlayEnd){
                                this.playVideo()
                            }
                        }
                    },300)
                   
                    
                    
                }else{
                    // 是外部链接
                    if(this.paperTotalFlag){
                        this.testDialogVisible = true;
                    }
                }
                
            },
            // 公司logo
            getLogo(){
                this.$ajax({
                    url:this.$config.baseApi + "/account/company/wx",
                    method:'post'
                }).then(res=>{
                    if(res.code == 1){
                        let companyName = res.data.companyName;
                        let logo = res.data.logo;
                        if(companyName){
                            localStorage['companyName']=companyName;
                        }
                        if(logo){
                            localStorage['logo']=logo;
                        }else{
                            localStorage['logo']="";
                        }
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 通过资源id获取试卷
            newPaperList(resourceId) {
                let url = this.$config.baseApi + "/material/resource/" +resourceId + "/paper";
                this.$ajax({
                    url: url,
                    method: "post",
                })
                .then(res => {
                    if (res.code == 1) {
                        let paperId = res.data.paperId;
                        let companyId = res.data.companyId;
                        this.linkFlag = true;
                        this.$router.push('./goTest?companyId='+ companyId +'&paperId=' + paperId + '&url=train')
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            },
             // 判断有无试卷
            newPaperList2(resourceId) {
                let url = this.$config.baseApi + "/material/resource/" +resourceId + "/paper";
                this.$ajax({
                    url: url,
                    method: "post",
                })
                .then(res => {
                    if (res.code == 1 && res.data.paperId != undefined) {
                        // 有试卷时
                        this.paperTotalFlag = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            },
             // 需要填写信息
            submitPerson(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogFormVisible2 = false;
                        this.submitMessage
                        this.submitMessage()
                    } else {
                        return false;
                    }
                });
            },
            goPerson(){
                this.dialogFormVisible2 = true;
                this.personDialogVisible = false;
            },
            submitMessage(){
                 this.$ajax({
                    url:this.$config.baseApi + "/account/wx/change/info",
                    method:'post',
                    data:JSON.stringify({
                        'realName':this.form2.name,
                        'mobile':this.form2.department,
                        'companyName':this.form2.company,
                        'departmentName':this.form2.department,
                    })
                }).then(res=>{
                    if(res.code == 1){
                        // this.getPaper()
                        if(this.linkFlag){
                            this.resourceBind();
                        }else{
                            this.getDetail(this.id);
                        }
                        this.$message({
                            message:res.msg,
                            type:"success"
                        })
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 进度条的颜色
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#f56c6c';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#67c23a';
                }
            },
            //  转换秒为00:00:00
            changeSecond(num){
                let hour = parseInt(num / (60 * 60));
                let min = parseInt(num % (60 * 60) / 60);
                let se = parseInt(num % (60 * 60) % 60)
                return this.mendZero(hour) + ':' + this.mendZero(min)+ ':' + this.mendZero(se)
            },
            // 补0
            mendZero(num){
                return num = num < 10 ? '0' + num : num;
            },
            fullScreen() {
                const player = this.$refs.videoPlayer.player
                player.requestFullscreen()//调用全屏api方法
                player.isFullscreen(true)
                player.play()
            },

            // 监听播放
            onPlayerPlay(player) {
                player.play()
                this.paused = false;
                this.isPlay = true;
                this.videoTotalTime = player.cache_.duration
                this.initTimerInstance()
                this.startRealTimer()
            },
            // 开始计时
            startRealTimer() {
                this.realTimer && clearInterval(this.realTimer);
                if (this.curPageUrl && this.curPageUrl != this.$route.path) {
                    return false;
                }
                this.realTimer = setInterval(() => {
                    this.addDown()
                }, 1000)
            },
            // 计时操作
            addDown(){
                if(this.realTime<this.videoTotalTime){//最大时间为视频的总时长
                    this.realTime+=1
                }else{
                    clearInterval(this.realTimer);
                    this.realTimer = null
                }
            },
            // 监听暂停
            onPlayerPause(player) {
                this.paused = true
                // this.clearTimerInstance()
                clearInterval(this.realTimer);
                this.realTimer = null
            },
            // 恢复播放进度
            playerReadied (player) {
                player.currentTime(this.gklog)
            },
            onPlayerWaiting(player) {
                this.$message({
                    message:'视频加载中，请稍后观看',
                    duration:"3000"
                })
                this.paused = true
                this.isPlay = false;
                this.$refs.videoPlayer.player.pause();
                clearInterval(this.realTimer);
                this.realTimer = null
            },
            /* 获取视频播放进度 */
            onPlayerTimeupdate (player) {
                this.gklog = player.cache_.currentTime
            },
            //监听媒体是否已到达结尾，播放完
            onPlayerEnded (player) {
                // 获取当前播放的index 加1 是下一个
                this.isPlayEnd = true
                let videoNum = Number(localStorage['videoNum']) + 1;
                this.clearTimerInstance()
                this.timerInstance = null
                this.submit()
                // 当前视频播放完了
                clearInterval(this.realTimer);
                this.realTimer = null
                this.realTime = 1
            },
            // 由于默认获取视频进度过于频繁通过计时器减少服务器请求（只有在播放时请求）
            putLearningObj () {
                if (!this.paused) {
                    // console.log('putLearningObj ~~~~~~~~~' + this.gklog)
                }
            },
            // 播放下一条视频
            playVideo(){
                let videoNum = Number(localStorage['videoNum']) + 1;
                let msg = ""
                if(this.videoList && this.videoList.length){
                    if(videoNum >= this.videoList.length){
                        msg = "该系列视频已播放完"
                    }else{
                        msg = "视频已结束，即将播放下一条视频"
                        setTimeout(()=>{
                            this.addSrc(this.videoList[videoNum],videoNum)
                        }, 1500)
                    }
                    this.$message({
                        message:msg,
                        type:"success",
                        duration:"6000",
                    })
                }
            },
            // 自动提交
            initTimerInstance() {
                this.clearTimerInstance()
                this.timerInstance = setInterval(() => {
                    this.submit()
                }, 60000)
            },
            clearTimerInstance() {
                clearInterval(this.timerInstance)
                this.timerInstance = null
            }
        },
        mounted(){
            document.title=this.$route.meta.title;
            this.putLearningObj()
            this.timer = setInterval(this.putLearningObj, 3000)
            // let videoPro = document.getElementById('vjs_video_3892_html5_api')
            // videoPro.style.cssText='display:none;'
        },
        created(){
            this.curPageUrl = this.$route.path;
            this.videoWidth = document.body.clientWidth * 0.6;
            if(this.$IsPc()){
                this.dialogWidth = "80%";
                this.videoWidth = document.body.clientWidth * 0.7;
                this.videoHeight = 150;
                this.certDialogWidth = "6rem";
                this.fromTo = 1 
            };
            this.startTime = timeChange(new Date())
            this.getTime();
            // 判断有无resourceId和companyId，调用绑定资源
            let trainLink = window.location.href
            if(trainLink.indexOf('url') > -1){
                this.redirectUrl = getQuery('url')
            }
            // 外部
            if(trainLink.indexOf('companyId') > -1 && trainLink.indexOf('resourceId') > -1){
                // this.videoList = []
                // this.noVideoList = true;
                this.linkFlag = true;
                this.linkResourceId = getQuery('resourceId');
                this.linkCompanyId = getQuery('companyId');
                this.resourceBind(); //外部资源进入绑定加调用详情
                this.getLogo();
            }else{
                this.getGroupDetail(this.id)
                // 判断是否被收藏
                this.checkCollect()
                this.firstVideo(this.id)
            }
        },
        computed: {
            // 获取路由传的ID
            id(){
                // return this.$route.query.id ? this.$route.query.id : ""
                return this.$route.query.id ? this.$route.query.id : (this.linkCourseId ? this.linkCourseId : '')
            },
            coursename(){
                // return this.$route.query.coursename ? this.$route.query.coursename : ""
                return this.$route.query.coursename ? this.$route.query.coursename : (this.linkCourseName ? this.linkCourseName : '')
            },
            player() {
                return this.$refs.videoPlayer.player
            }
        },
        // 页面离开
        destroyed() {
            this.realTimer && clearInterval(this.realTimer);

            localStorage.removeItem("videoNum")
            // 销毁定时器
            if (this.timer) {
                clearInterval(this.timer);
                clearInterval(this.timer2);
            }
            clearInterval(this.timerInstance)
            this.timerInstance = null
        },
        beforeDestroy() {
            this.curPageUrl = "endTimer";
            this.realTimer && clearInterval(this.realTimer);
        },
    }
</script>

<style scoped>
@import "../../../assets/css/home/home.css";
    .videoParent{
        margin-top:0.4rem;
        display: flex;
        justify-content: space-between;
    }
    .videoLeft{
        width:69%;
        text-align:center;
        height: 6.2rem;
        background:#fff;
    }
    .videoRight{
        width:30%;
        height: 6.2rem;
        background: #fff;
    }
    .rightList{
        height: 5.52rem;
        overflow: auto;
        padding-left:3%;
    }
    /* 侧视频列表 */
    .videoTitle{
        width:100%;
        font-size:0.2rem;
        height: 0.48rem;
        color:#fff;
        text-align: center;
        background:rgba(42, 130, 228, 1) ;
        font-weight: bold;
        line-height: 0.48rem;
    }
    .videoItem{
        width: 100%;
        height: 0.95rem;
        font-size:0.14rem;
        color:rgba(80, 80, 80, 1);
        display: flex;
        justify-content:space-between;
        margin-top:0.26rem;
    }
    .videoItem .leftImg{
        width:30%;
        height: 100%;
        cursor: pointer;
        position: relative;
    }
    .videoItem .leftImg img{
        width:100%;
        height: 100%;
    }
    .shadow{
        height: 100%;
        width:100%;
        background:rgba(42, 130, 228, .6);
        position: absolute;
        top:0;left:0;
        color:#fff;
        font-size:0.16rem;
        font-weight: bold;
        text-align: center;
        line-height: 0.95rem;
    }
    .mImg{
        position: relative;
        width:100%;
    }
    .mobileShadow{
        height: 1.84rem;
        width:100%;
        background:rgba(42, 130, 228, .6);
        position: absolute;
        top:0;left:0;
        color:#fff;
        font-size:0.28rem;
        font-weight: bold;
        text-align: center;
        line-height: 1.84rem;
    }
    .videoItem .rightTxt{
        width:70%;
        padding-left:0.1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .rightTxt .title{
        font-size:0.17rem;
        font-weight: bold;
    }
    .rightTxt .studyTime{
        position: relative;
    }
    .rightTxt .testBtn{
        color:rgba(42, 130, 228, 1);
        cursor: pointer;
    }
    .rightTxt .studyProgress{
        display: flex;
    }
    .studyProgress{
        width:100%;
    }
    .studyProgress div:nth-child(2){
        width:65%;
    }
    .studyProgress .el-progress{
        margin:0;
    }
    .rightTxt img.lock{
        height: 0.2rem;
        width:0.2rem;
        position:absolute;
        right:0.2rem;bottom:0rem;
    }

    .timeRecoder{
        font-size: 0.15rem;
        color: #333;
        width: 7.5rem;
        margin: 0.3rem auto 0;
        text-align: left;
    }
    .player{
        width:7.5rem;
        margin: 0 auto;
        position: relative;
    }
    .videoList{
        text-align:left;
        width: 67%;
        margin:0 auto;
        border-top:1px solid #ccc;
        display:none;
    }
    .videoList .title,.proTitle{
        text-align: left;
        margin:0.2rem 0;
        font-size: 0.18rem  ;
    }
    .proTitle{
        width: 100%;
        margin:0;
    }
    .videoList .videoCont{
        padding-bottom:1%;
        overflow: hidden;
    }
    .trainItem{
        width:22%;
        margin:1% 1.5% 0;
    }
    .mProgress{
        position: relative;
        font-size:0.24rem;
        font-weight: normal;
    }
    .mProgress img{
        height: 0.35rem;
        width:0.35rem;
        position: absolute;
        top:-0.05rem;
        right:0;
    }

    .mainCont{
        /* background: #fff; */
        padding:0.17rem 0rem;
        position: relative;
    }
    .mobileTest{
        display: none;
        margin-top: 1.2rem;
    }
    .tip{
        color:#417ccb;
        font-weight: bold;
        font-size: 0.15rem;
        margin-top:0.2rem
    }
    .comBtn{
        margin:0.3rem auto 0.2rem;
        width: 2rem;
        font-size:14px;
        line-height: 0.20rem;
    }
    .gt_back{
        position: absolute;
        top:0.17rem;
    }
    .trainName{
        font-size: 0.24rem;
        color:rgba(80, 80, 80, 1);
        display:flex;
        height:0.8rem;
        justify-content: space-between;
        align-items: center;
        padding-right:0.2rem;
        padding: 0.1rem;
    }
    .trainName div:nth-child(3){
        font-size:0.12rem;
        cursor: pointer;
    }
    .trainName div:nth-child(3) img{
        width:0.25rem;
        display: block;
        margin:0 auto 0.05rem;
    }
    .teacherName,.introduce{
        font-size:0.16rem;
        color:rgba(80, 80, 80, 1);
        text-align: left;
        width: 100%;
        /* margin-left:16.5%; */
    }
    .introduce{
        margin-top:0.1rem;
    }
    .teacherName{
        margin-top:0.2rem;
    }
    .personMess{
    font-size:0.2rem;
    }
    .personMess div:nth-child(1){
        text-align: center;
    }
    .personMess div:nth-child(2){
        text-align: right;
        margin-top:0.2rem;
        color:#417ccb;
        cursor: pointer;
    }
    .personTip{
        color: #417ccb;
        text-align: left;
        font-size:0.16rem;
        padding-left:0.15rem;
    }
    .instroduceP{
        margin-top:0.13rem;
        background:#fff;
        padding:0.2rem;
    }
    .newTestBtn{
        height: 0.48rem;
        width:97%;
        background:#2a82e4;
        color:#fff;
        font-size:0.16rem;
        font-weight: bold;
        display:flex;
        align-items: center;
        margin-top:0.26rem;
        cursor: pointer;
    }
    .jj{
        position: relative;
        margin:0 auto;
    }
    .jj span{
        display:inline-block;
        padding-left:0.28rem;
    }
    .newTestBtn img{
        height: 0.2rem;
        width:0.18rem;
        position: absolute;
        top:0;
        left:0;
    }
    .isCollect{
        width: 0.44rem;
    }
    @media screen and (max-width: 768px) {
        .parentCont{
            width:100%;
            min-height:4.2rem ;
            background:#e6e6e6;
        }
        .isCollect{
            width: 0.88rem;
        }
        .newTestBtn{
            height: 0.9rem;
            width:94%;
            font-size:0.3rem;
            margin:0.2rem auto 0.4rem;
        }
        .jj span{
            padding-left:0.5rem;
        }
        .newTestBtn img{
            height: 0.34rem;
            width:0.36rem;
        }
        .instroduceP{
            margin-top:0;
            padding:0;
        }
        .videoParent{
            margin-top:0rem;
        }
        .videoRight{
            display: none;
        }
        .videoLeft{
            width:100%;
            height: 6.1rem;
        }
        .player{
            width: 100%;
        }
        .timeRecoder{
            width: 95%;
            font-size:0.24rem;
        }
        .trainItem{
            width:44%;
            height:3.8rem;
            margin:2% 3%;
        }
        .videoList{
            margin-top:0.4rem;
            width: 100%;
            display:block;
        }
        .videoList .title{
            width:90%;
            margin:0.3rem auto 0.15rem;
        }
         .teacherName,.introduce{
            width: 90%;
            margin-left:0;
            margin:0 auto;
        }
        .videoList .title,.proTitle{
            text-align: left;
            font-size: 0.32rem  ;
        }
         .proTitle{
            width: 90%;
            margin:0.2rem auto;
        }
        .mobileTest {
            display: block;
        }
        .mainCont {
            margin-top:0.9rem;
            box-sizing: border-box;
            padding:0 0 0.4rem;
            background: #fff;
        }
        .gt_back{
            display: none;
        }
        .tip{
            font-size: 0.24rem;
            margin-top:0.2rem;
            padding:0rem  2%;
        }
        .comBtn{
            margin:0.3rem auto 0.2rem;
            width: 3rem;
            font-size:0.24rem;
        }
        .trainName{
            font-size: 0.32rem;
            height:1rem;
            padding-right:0.2rem;
        }
        .trainName div:nth-child(3){
            font-size:0.24rem;
            cursor: pointer;
        }
        .trainName div:nth-child(3) img{
            width:0.4rem;
            display: block;
            margin:0 auto 0.05rem;
        }
        .teacherName,.introduce{
            font-size:0.26rem;
        }
        .personMess{
            font-size:0.34rem;
        }
        .personTip{
            font-size:0.24rem;
            padding-left:0.2rem;
        }
        .mTxt{
            /* height:2rem; */
            width:100%;
            display:flex;
            flex-direction: column;
            justify-content: space-around;
        }
        .mTxt .mGoTest{
            color:#2a82e4;
        }
        .mobileTestBg{
            width:44%;
            height:3.8rem;
            background:url(../../../assets/images/common/qr_bg.png) no-repeat center;
            background-size:cover;
            float:left ;
            margin:2% 3%;
            position: relative;
        }
        .mobileTestBg .topImg{
            width:40%;
            margin:0.2rem;
        }
        .mobileTestBg .centerImg{
            height: 1.3rem;
            position: absolute;
            top:50%;left:50%;
            transform: translate(-50%,-50%);
        }
        .mobileTestBg .mtxt{
            color:#fff;
            font-size:0.3rem;
            text-align:center;
            font-weight:bold;
            margin-top:1.8rem;
        }
    }
</style>
